import { render, staticRenderFns } from "./DFieldImage.vue?vue&type=template&id=04870474&scoped=true&"
import script from "./DFieldImage.vue?vue&type=script&lang=js&"
export * from "./DFieldImage.vue?vue&type=script&lang=js&"
import style0 from "./DFieldImage.vue?vue&type=style&index=0&id=04870474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04870474",
  null
  
)

export default component.exports